import { useState } from 'react';
import DB from '../../data/mockData';

export default function AddProductModal({ show, onClose }) {
  const [name, setName] = useState('');

  if (!show) return null;

  const handleAdd = () => {
    onClose();
  };

  return (
    <div className="modal-backdrop-fo" onClick={onClose}>
      <div className="modal-fo" onClick={e => e.stopPropagation()}>
        <button className="mcl" onClick={onClose}>✕</button>
        <div className="m-title">Add New Product</div>
        <div className="m-sub">Nova auto-classifies molecule type and checks NL availability after saving</div>

        <div className="row g-3 mb-3">
          <div className="col-sm-6">
            <label className="flabel">Product Name</label>
            <input className="finput" placeholder="e.g. Amlodipine 5 mg Tablet" value={name} onChange={e => setName(e.target.value)} />
          </div>
          <div className="col-sm-6">
            <label className="flabel">INN / Molecule</label>
            <input className="finput" placeholder="e.g. Amlodipine" />
          </div>
        </div>
        <div className="row g-3 mb-3">
          <div className="col-sm-6">
            <label className="flabel">Pharmaceutical Form</label>
            <select className="finput"><option>Tablet</option><option>Capsule</option><option>Injection</option><option>Infusion</option><option>Cream</option></select>
          </div>
          <div className="col-sm-6">
            <label className="flabel">Strength</label>
            <input className="finput" placeholder="e.g. 5 mg or 500 mg/2 mL" />
          </div>
        </div>
        <div className="row g-3 mb-3">
          <div className="col-sm-6">
            <label className="flabel">Supplier</label>
            <select className="finput">
              {DB.suppliers.map(s => <option key={s.id}>{s.name}</option>)}
            </select>
          </div>
          <div className="col-sm-6">
            <label className="flabel">Dossier Type</label>
            <select className="finput"><option>EU CTD</option><option>DCP</option><option>National</option><option>Unknown</option></select>
          </div>
        </div>
        <div className="row g-3 mb-3">
          <div className="col-sm-6">
            <label className="flabel">NL Available</label>
            <select className="finput"><option>Yes</option><option>No</option><option>Expected</option></select>
          </div>
          <div className="col-sm-6">
            <label className="flabel">MA Status</label>
            <select className="finput"><option>Marketed</option><option>In progress</option><option>Expected Q3 2026</option><option>Unknown</option></select>
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 pt-3 border-top">
          <button className="btn btn-s" onClick={onClose}>Cancel</button>
          <button className="btn btn-p" onClick={handleAdd}>Add Product</button>
        </div>
      </div>
    </div>
  );
}
